/*
 * @Autor: 杨华
 * @Version: 1.0
 * @Date: 2019-11-26 15:16:55
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-08-19 16:17:44
 */
import { objAny } from "../common/common-interface";
let configData = {
  loginUrl: null,
  ajaxHost: process.env.VUE_APP_BASE_API, // 接口公用的一段
  apiStatus: 0,
  host: "",
  footText: "",
  footTextEnglish: "",
  formSize: "default", // 全局按钮表单的大小
  pickerOptions: {
    disabledDate(time: objAny) {
      return (
        time.getTime() > new Date(new Date().toLocaleDateString()).getTime()
      );
    }
  },
  pickerOptionsMin: {
    disabledDate(time: objAny) {
      return (
        time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
      );
    }
  },
  draggable: false, // 弹出框是否可以拖动
  mapKeyApi: "38963cf6e1d7092a3dfcf940b4979bd5",
  echartsJS: "./echarts.min.js",
  fileImg: process.env.VUE_APP_BASE_FILE, // 图片路径要加上这一段才能显示出来
  sysModulePkId: "3", // 系统管理的菜单Id
  footerUrl: "https://beian.miit.gov.cn",
  powerObj: {
    // 权限对应的code,在页面里面直接用 xx.query 来做按钮权限,权限直接加入到 $route.meat 里面的 privilegeVoList
    "100501": "query", // 浏览
    "100502": "add", // 新增
    "100503": "updata", // 修改
    "100504": "delete", //删除
    "100505": "logout", // 注销
    "100506": "audit", // 审核
    "100507": "handle", // 处理
    "100508": "export", // 导出
    "100509": "endOrder", // 结束订单
    "100510": "grant", // 发放
    "100511": "stop", // 停用
    "100512": "relevance", // 关联
    "100513": "cancelRelevance", // 取消关联
    "100514": "recharge", // 充值
    "100515": "refund", // 退款
    "100516": "blacklist", // 黑名单
    "100517": "openCar", // 开卡
    "100518": "Import", // 导入
    "100519": "give", // 赠送
    "100520": "invalid", // 失效
    "100521": "site", // 解绑/绑定站点
    "100522": "line" // 上下线
  },
  tableStripe: true,
  position: {
    lat: 22.546054,
    lng: 114.025974,
    city: ""
  },
  socketServer: "ws://127.0.0.1:8784/Pilot", // 'ws://192.168.0.19:8784/Pilot', // "ws://127.0.0.1:8784/Pilot"
  downloadUrl:
    "http://files.qn.smartpevc.com/%E6%B4%BE%E8%AF%BA%E5%8F%91%E5%8D%A1%E6%8F%92%E4%BB%B620191209.exe", // 插件
  downloadUrl32: "http://files.qn.smartpevc.com/USB%E8%BD%ACRS232_WIN.zip", // 驱动
  downloadUrlXP32: "http://files.qn.smartpevc.com/USB%E8%BD%ACRS232_XP.zip", // XP系统 驱动
  downLoadNet35:
    "http://download.microsoft.com/download/2/0/E/20E90413-712F-438C-988E-FDAA79A8AC3D/dotnetfx35.exe",
  onLineMax: null,
  offLineMax: null,

  languageShow: true
};
//为了防止哪天在域名中间加了东西 或者接口域名变了 ，然后外面连接一个js 文件 js 文件里放这几个参数就可以了
// 其它打包路径已设置为相对路径 ,只和 static  和 index.html 文件 在同一层级就可以了
const win: objAny = window;
if (win.appConfig && typeof win.appConfig == "object") {
  configData = Object.assign(configData, win.appConfig);
}
export default configData;
